import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Boxes } from "lucide-react";
import { btnPrimary } from "./primitives";

const NAV_LINKS = [
  { label: "Why BulkContainer", href: "#why" },
  { label: "How it Works", href: "#how" },
  { label: "Workspace", href: "#workspace" },
  { label: "Outcomes", href: "#outcomes" },
  { label: "FAQ", href: "#faq" },
];

export default function Navbar({ onOpenLead }) {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="navbar"
      className="fixed inset-x-0 top-0 z-50 border-b border-slate-200/60 bg-white/70 backdrop-blur-xl"
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6 lg:px-8">
        <a href="#top" data-testid="brand-logo" className="flex items-center gap-2.5">
          <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#0052FF] text-white shadow-[0_6px_16px_-4px_rgba(0,82,255,0.6)]">
            <Boxes className="h-[18px] w-[18px]" strokeWidth={2.2} />
          </span>
          <span className="font-display text-[15px] font-bold tracking-tight text-[#0A1128]">
            BulkContainer<sup className="ml-0.5 text-[9px] text-[#94A3B8]">™</sup>
          </span>
          <span className="hidden items-center gap-1.5 border-l border-slate-200 pl-2.5 text-xs font-medium text-[#94A3B8] sm:flex">
            by DeMaxtore
          </span>
        </a>

        <div className="hidden items-center gap-8 lg:flex">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm font-medium text-[#475569] transition-colors hover:text-[#0A1128]"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="hidden items-center gap-3 lg:flex">
          <button
            data-testid="nav-signin"
            onClick={() => onOpenLead("sign_in")}
            className="text-sm font-medium text-[#475569] transition-colors hover:text-[#0A1128]"
          >
            Sign in
          </button>
          <button
            data-testid="nav-cta"
            onClick={() => onOpenLead("create_workspace")}
            className={btnPrimary + " !px-5 !py-2.5"}
          >
            Create Free Workspace
          </button>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="flex h-9 w-9 items-center justify-center rounded-lg text-[#0A1128] lg:hidden"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="overflow-hidden border-t border-slate-200/60 bg-white lg:hidden"
          >
            <div className="space-y-1 px-6 py-4">
              {NAV_LINKS.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="block rounded-lg px-3 py-2.5 text-sm font-medium text-[#475569] hover:bg-slate-50"
                >
                  {l.label}
                </a>
              ))}
              <button
                onClick={() => {
                  setOpen(false);
                  onOpenLead("create_workspace");
                }}
                className={btnPrimary + " mt-2 w-full"}
              >
                Create Free Workspace
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
